import A11yMenu from './_a11yMenu';
import IsInView from './_isInView';
import Swiper from 'swiper';
import {
	Autoplay, Navigation, A11y,
} from 'swiper/modules';

import {
	OverlayScrollbars,
	ScrollbarsHidingPlugin,
	ClickScrollPlugin,
	SizeObserverPlugin,
} from 'overlayscrollbars';

const initScroll = function initScroll() {
	const scrolls = document.querySelectorAll('.grid-scroll');
	if (scrolls) {
		OverlayScrollbars.plugin([SizeObserverPlugin, ScrollbarsHidingPlugin, ClickScrollPlugin]);
		scrolls.forEach((elt) => {
			OverlayScrollbars(elt, {
				overflow: {
					y: 'hidden',
				},
				scrollbars: {
					theme: 'os-theme-dark',
					visibility: 'auto',
					clickScroll: true,
				},
			}, {
				updated(osInstance) {
					// For accessibility

					const scrollableDiv = osInstance.elements().content;
					if (osInstance.state().hasOverflow.x) {
						scrollableDiv.setAttribute('tabindex', 0);
						scrollableDiv.setAttribute('role', 'region');
						scrollableDiv.setAttribute('aria-label', 'Contenu avec scroll');
					} else {
						scrollableDiv.setAttribute('tabindex', -1);
						scrollableDiv.removeAttribute('role');
						scrollableDiv.removeAttribute('aria-label');
					}
				},
			});
		});
	}
};

const initMultiSlider = function initMultiSlider() {
	const sliders = document.querySelectorAll('.multiblocks-swiper');
	sliders.forEach((elt) => {
		const nbCols = elt.getAttribute('data-tabCols');
		const swiper = new Swiper(elt, {
			modules: [Navigation, A11y],
			slidesPerView: 1,
			spaceBetween: 36,
			enabled: true,
			init: false,
			watchOverflow: false,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				prevSlideMessage: 'élément précédent',
				nextSlideMessage: 'élément suivant',
			},
			navigation: {
				nextEl: elt.querySelector('.swp-button-next'),
				prevEl: elt.querySelector('.swp-button-prev'),
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					enabled: true,
				},
				720: {
					slidesPerView: nbCols,
					enabled: true,
				},
				960: {
					enabled: false,
				},
			},
		});

		swiper.on('breakpoint', (swipe, breakpointParams) => {
			if (!breakpointParams.enabled) {
				swipe.el.classList.add('disabled');
			} else {
				swipe.el.classList.remove('disabled');
			}
		});
		swiper.init();
	});

	const slidersDrag = document.querySelectorAll('.drag-swiper');
	slidersDrag.forEach((elt) => {
		const swiper = new Swiper(elt, {
			modules: [Navigation, A11y],
			enabled: true,
			init: false,
			slidesPerView: 1,
			spaceBetween: 60,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				prevSlideMessage: 'élément précédent',
				nextSlideMessage: 'élément suivant',
			},
			navigation: {
				nextEl: '.swp-button-next',
				prevEl: '.swp-button-prev',
				clickable: true,
				enabled: true,
			},
			breakpoints: {
				375: {
					slidesPerView: 1,
					navigation: {
						enabled: true,
					},
				},
				640: {
					slidesOffsetBefore: 30,
					slidesPerView: 'auto',
					navigation: {
						enabled: false,
					},
				},
			},
		});
		swiper.init();
	});
};
document.addEventListener('DOMContentLoaded', () => {
	const menu = new A11yMenu(document.querySelector('.a11y-nav-block'), '56rem');
	menu.menuSetup();

	// ANIMATIONS
	if ('IntersectionObserver' in window) {
		const checkInView = new IsInView('.is-in-view', 0.20);
		checkInView.init();
	}

	initScroll();
	initMultiSlider();

	const marqueeSlider = document.querySelectorAll('.marquee-swiper');
	if (marqueeSlider) {
		marqueeSlider.forEach((elt) => {
			const swiper = new Swiper(elt, {
				modules: [Autoplay],
				init: false,
				slidesPerView: 'auto',
				loop: true,
				speed: 3000,
				autoplay: {
					delay: 1,
				},
				breakpoints: {
					720: {
						speed: 5500,
					},
				},
			});
			swiper.init();
		});
	}
});
